module.exports = __webpack_public_path__ + "media/images/coupon/answer-4c7729e6454d74449000f627aa430c95.png";